export default __webpack_public_path__ + "static/media/header.893a6542.png";